export default __webpack_public_path__ + "666a1e1d6e4e87ba2226c4eaf8c4c638.svg";